import { Component, OnInit } from '@angular/core';
import { AppConstants } from '@core/constants/app';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit{

  public company = {
    name: `@${new Date().getFullYear()} HF Management Services, LLC`,
    number: '1032-20',
  };
  public applicationYear: string;
  public links: Array<{ name: string, value: string }>

  constructor(private translate: TranslateService){
    this.links = [
      {
        name: `footer.links.TermsAndConditions`,
        value: AppConstants.TERMS_AND_CONDITIONS_URL_MAPPING()[this.translate.currentLang],
      },
      {
        name: `footer.links.WebPrivacyStatement`,
        value: AppConstants.PRIVACY_POLICY_URL_MAPPING()[this.translate.currentLang],
      },
      {
        name: `footer.links.NewYorkPrivacyNotice`,
        value: AppConstants.NEW_YORK_PRIVACY_NOTICEY_URL_MAPPING()[this.translate.currentLang],
      },
      {
        name: `footer.links.HIPAAPrivacyNotice`,
        value: AppConstants.HIPPA_PRIVACY_NOTICE_URL_MAPPING()[this.translate.currentLang],
      },
    ];
  }

  public openNewWindow(link) {
    window.open(link, '_blank');
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.links[0].value = AppConstants.TERMS_AND_CONDITIONS_URL_MAPPING()[event.lang]
      this.links[1].value = AppConstants.PRIVACY_POLICY_URL_MAPPING()[event.lang]
      this.links[2].value = AppConstants.NEW_YORK_PRIVACY_NOTICEY_URL_MAPPING()[event.lang]
      this.links[3].value = AppConstants.HIPPA_PRIVACY_NOTICE_URL_MAPPING()[event.lang]
    });
  }


}
